<template>
    <div>
        <!-- Dados com layout em Grid -->
        <div class="data-grid">
            <div class="data-item">
                <span class="label">Inscrição Imobiliária:</span>
                <span class="value">{{ props.data.fatherId }}</span>
            </div>
            <div class="data-item">
                <span class="label">Setor</span>
                <span class="value">{{ props.data.sector }}</span>
            </div>
            <div class="data-item">
                <span class="label">Quadra:</span>
                <span class="value">{{ props.data.block }}</span>
            </div>
            <div class="data-item">
                <span class="label">Lote:</span>
                <span class="value">{{ props.data.subdivision }}</span>
            </div>
        </div>
        <br>

       <h6>Edificações</h6>
        <a-tabs style="margin-top: 24px" type="card" class="inner-tabs">
            <a-tab-pane v-for="(building, key) in props.data.buildings" :key="key" :tab="building.id">
                <div class="data-grid">
                    <div class="data-item">
                        <span class="label">Inscrição Imobiliária:</span>
                        <span class="value">{{ building.propertyId }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Data de Lançamento:</span>
                        <span class="value">{{ formatDate(building.releaseDate) }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Ano de Construção:</span>
                        <span class="value">{{ building.year }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Área (m2):</span>
                        <span class="value">{{ formatArea(building.area) }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Pavimento:</span>
                        <span class="value">{{ building.pavement }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Logradouro:</span>
                        <span class="value">{{ building.address.streetName }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Numero:</span>
                        <span class="value">{{ building.address.number }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Complemento:</span>
                        <span class="value">{{ building.address.complement }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Principal:</span>
                        <span class="value">{{ building.isMain ? 'SIM' : 'NÃO' }}</span>
                    </div>
                </div>

                <a-tabs style="margin-top: 24px" type="card" class="inner-tabs" :tabBarStyle="tabBarStyle">
                    <a-tab-pane key="1" tab="Características">
                        <div class="data-grid">
                            <div class="data-item" v-for="characteristic in building.characteristics">
                                <div class="label">{{ characteristic.group.description }}</div>
                                <div class="value">{{ characteristic.description }}</div>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2">
                        <template #tab>
                            <p style="text-align:center; margin-bottom:0">Observações<br>cadastro</p>
                        </template>
                        <div style="display:flex; flex-direction:column; align-items:end; padding: 0 10px">
                            <a-textarea v-model:value="building.newCadObs" :rows="10" allow-clear :auto-size="{ minRows: 10, maxRows: 10 }"
                                        :readonly="!building.editingCadObs" :class="{ 'readonly-cursor': !building.editingCadObs }" />

                            <div style="display:flex; margin-top:10px; gap:10px">
                                <a-button v-if="building.editingCadObs" type="text" size="large" v-text="'Cancelar'" :disabled="loading"
                                          @click="() => { building.editingCadObs = false; building.newCadObs = building.obs; }" />
                                <a-button :type="building.editingCadObs ? 'primary' : 'default'" size="large" :loading="loading"
                                          :disabled="!specificFuncPermissions[1]" @click="handleCadObs(building)">
                                    {{ building.editingCadObs ? 'Atualizar' : 'Editar' }}
                                </a-button>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3">
                        <template #tab>
                            <p style="text-align:center; margin-bottom:0">Observações<br>Geo</p>
                        </template>

                        <div style="display:flex; flex-direction:column; align-items:end; padding: 0 10px">
                            <a-textarea v-model:value="building.newGeoObs" :rows="10" allow-clear :auto-size="{ minRows: 10, maxRows: 10 }"
                                        :readonly="!building.editingGeoObs" :class="{ 'readonly-cursor': !building.editingGeoObs }" />

                            <div style="display:flex; margin-top:10px; gap:10px">
                                <a-button v-if="building.editingGeoObs" type="text" size="large" v-text="'Cancelar'" :disabled="building.loading"
                                          @click="() => { building.editingGeoObs = false; building.newGeoObs = building.oldGeoObs }" />
                                <a-button :type="building.editingGeoObs ? 'primary' : 'default'" size="large" :loading="building.loading"
                                          :disabled="!specificFuncPermissions[2]" @click="handleGeoObs(building)">
                                    {{ building.editingGeoObs ? 'Atualizar' : 'Editar' }}
                                </a-button>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script setup>
import {defineProps, ref, onMounted} from 'vue'
import axios from "axios";
import {notification} from "ant-design-vue";
import verifySpecificFuncPermissions from "../../../../../../utils/verifySpecificFuncPermissions";
import { openNotification } from '../../../../../../utils/utilities';

const specificFuncPermissions = ref({})
const loading = ref(false)

onMounted(async () => {
    specificFuncPermissions.value = await verifySpecificFuncPermissions()

    for (const building of props.data.buildings) {
        building.newCadObs = building.cadObs
        building.editingCadObs = false

        building.oldGeoObs = ''
        building.newGeoObs = ''
        building.editingGeoObs = false
        building.loading = false

        building.oldGeoObs = (await window.axios.get(`/api/map-actions/bic/${building.propertyId}/get-building-obs?idCons=${building.id}`)).data.data
        building.newGeoObs = building.oldGeoObs
    }
})

const props = defineProps({
    data:  [Object]
})

const handleGeoObs = async (building) => {
    (building.editingGeoObs)
        ? await saveGeoObs(building)
        : building.editingGeoObs = true
}

const saveGeoObs = async (building) => {
    loading.value = true

    const formData = new FormData()
    formData.append('obs', building.newGeoObs)
    formData.append('idCons', building.id)
    formData.append('_method', 'PUT');

    try {
        await window.axios.post(`/api/map-actions/bic/${building.propertyId}/save-building-obs`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        openNotification('success', 'Observação atualizada com sucesso!')
        building.oldGeoObs = building.newGeoObs
        building.editingGeoObs = false
    } catch (error) {
        openNotification('error', 'Houve algum erro ao atualizar a observação.')
    }

    loading.value = false
}

const formatArea = (area) => {
    return Number(area).toFixed(2);
}
 const formatDate = (date) => {
    if (!date) return '—';
    return new Date(date).toLocaleDateString('pt-BR');
}

const tabBarStyle = {
    fontSize: '10px',
    padding: '0 6px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
};

const handleCadObs = async (building) => {
    (building.editingCadObs)
        ? await saveCadObs(building)
        : building.editingCadObs = true
}

const saveCadObs = async (item) => {
    loading.value = true

    const formData = new FormData()
    formData.append('obs', item.newCadObs)
    formData.append('idCons', item.id)
    formData.append('_method', 'PUT');

    try {
        await window.axios.post(`/api/e-cidade/building/${item.propertyId}/save-obs`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        openNotification('success', 'Observação atualizada com sucesso!')
        item.editingCadObs = false
        item.obs = item.newCadObs
    } catch (error) {
        openNotification('error', 'Houve algum erro ao atualizar a observação.')
    }

    loading.value = false
}
</script>

<style scoped>
.data-grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* Duas colunas: uma para o campo e outra para o valor */
    gap: 8px; /* Espaço entre os itens */
    padding: 8px;
    max-width: 100%;
}

::v-deep(.ant-tabs-tab) {
    min-width: 100px;
    white-space: normal;
    text-align: center;
    justify-content: center;
}

.data-item {
    display: flex;
    flex-direction: column;
    padding: 4px 0;
    font-size: 14px;
}

.label {
    font-size: 12px;
    color: #888;
    font-weight: 500;
    margin-bottom: 2px;
    line-height: 1.2;
}

.value {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
}

::v-deep(.readonly-cursor.ant-input) {
    cursor: copy !important;
}
</style>
